module.exports = __webpack_public_path__ + "NeueFrutigerWorld-Heavy.66f4aacbb47cb39abf07.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/assets/fonts/neue-frutiger-world/NeueFrutigerWorld-Heavy.ttf
// module id = ../../../../../src/assets/fonts/neue-frutiger-world/NeueFrutigerWorld-Heavy.ttf
// module chunks = styles